// import { parse } from 'node-html-parser';

export function convertGeoFormatToRegex(geoFormat) {
  const regexArr = [];
  // split values
  const geoFormats = geoFormat[0].split('|');
  let outputStr;
  geoFormats.forEach((format) => {
    switch (format) {
      // United States, Puerto Rico"
      case '#####-####':
        outputStr = '(\\d{5}(-)?(\\d{4})?)';
        break;

      // Australia, New Zealand
      case '####':
        outputStr = '\\d{4}';
        break;

      // Canada
      case '@#@ #@#':
        outputStr = '[A-Z]{1}\\d{1}[A-Z]{1} \\d{1}[A-Z]{1}\\d{1}';
        break;

      // Ireland
      case '@@@ @@@@':
        outputStr = '[A-Z0-9]{3} [A-Z0-9]{4}'; // Ireland "@" customised to allow alpha numeric instead of just alpha
        break;

      // United Kingdom
      case '@# #@@':
        outputStr = '[A-Z]{1}\\d{1} \\d{1}[A-Z]{2}';
        break;

      // United Kingdom
      case '@## #@@':
        outputStr = '[A-Z]{1}\\d{2} \\d{1}[A-Z]{2}';
        break;

      // United Kingdom
      case '@@# #@@':
        outputStr = '[A-Z]{2}\\d{1} \\d{1}[A-Z]{2}';
        break;

      // United Kingdom
      case '@@## #@@':
        outputStr = '[A-Z]{2}\\d{2} \\d{1}[A-Z]{2}';
        break;

      // United Kingdom
      case '@#@ #@@':
        outputStr = '[A-Z]{1}\\d{1}[A-Z]{1} \\d{1}[A-Z]{2}';
        break;

      // United Kingdom
      case '@@#@ #@@':
        outputStr = '[A-Z]{2}\\d{1}[A-Z]{1} \\d{1}[A-Z]{2}';
        break;

      // Italy, South Korea, France
      case '#####':
        outputStr = '\\d{5}';
        break;

      // Singapore
      case '######':
        outputStr = '\\d{6}';
        break;

      // Japan
      case '###-####':
        outputStr = '(\\d{3}(-)?(\\d{4})?)';
        break;

      default:
        outputStr = format;
    }
    regexArr.push(`^${outputStr}$`);
  });

  return regexArr;
}
